// The ASQ result columns shared by both group cohort report tabs: every ASQ-3
// bucket first, then every ASQ-SE2 one. `column` is the translation key under
// groupCohortsReport.columns, `field` the serialized attribute.
export const ASQ_RESULT_COLUMNS = [
  { column: 'asq3Refer', field: 'asq3ReferCount' },
  { column: 'asq3Monitor', field: 'asq3MonitorCount' },
  { column: 'asq3Concern', field: 'asq3ConcernCount' },
  { column: 'asqSe2Refer', field: 'asqSe2ReferCount' },
  { column: 'asqSe2Monitor', field: 'asqSe2MonitorCount' },
  { column: 'asqSe2Concern', field: 'asqSe2ConcernCount' },
];

export default ASQ_RESULT_COLUMNS;
